var _rect, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgHistory = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_3048",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_3048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 35C16.1667 35 12.8264 33.7292 9.97917 31.1875C7.13194 28.6458 5.5 25.4722 5.08333 21.6667H8.5C8.88889 24.5556 10.1736 26.9444 12.3542 28.8333C14.5347 30.7222 17.0833 31.6667 20 31.6667C23.25 31.6667 26.0069 30.5347 28.2708 28.2708C30.5347 26.0069 31.6667 23.25 31.6667 20C31.6667 16.75 30.5347 13.9931 28.2708 11.7292C26.0069 9.46528 23.25 8.33333 20 8.33333C18.0833 8.33333 16.2917 8.77778 14.625 9.66667C12.9583 10.5556 11.5556 11.7778 10.4167 13.3333H15V16.6667H5V6.66667H8.33333V10.5833C9.75 8.80556 11.4792 7.43056 13.5208 6.45833C15.5625 5.48611 17.7222 5 20 5C22.0833 5 24.0347 5.39583 25.8542 6.1875C27.6736 6.97917 29.2569 8.04861 30.6042 9.39583C31.9514 10.7431 33.0208 12.3264 33.8125 14.1458C34.6042 15.9653 35 17.9167 35 20C35 22.0833 34.6042 24.0347 33.8125 25.8542C33.0208 27.6736 31.9514 29.2569 30.6042 30.6042C29.2569 31.9514 27.6736 33.0208 25.8542 33.8125C24.0347 34.6042 22.0833 35 20 35ZM24.6667 27L18.3333 20.6667V11.6667H21.6667V19.3333L27 24.6667L24.6667 27Z",
    fill: "#008908"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHistory, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/history.32dc4f05.svg";
export { ForwardRef as ReactComponent };